import { render, staticRenderFns } from "./addassettemplate.html?vue&type=template&id=4404fc97&"
import script from "./addassettemplate.vue?vue&type=script&lang=js&"
export * from "./addassettemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports